export default __webpack_public_path__ + "media/zurb/img/home/design-insight-icon-2-3866b686b98f5a605f1dbff8c344d720.svg";